import { useEffect, useState } from "react";
import { DownloadSimple, Printer, QrCode } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Strumenti() {
  const [content, setContent] = useState(window.location.origin);
  const [qrUrl, setQrUrl] = useState(null);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [reservations, setReservations] = useState(null);
  const [rid, setRid] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      setRid(r.data.restaurant_id);
      setContent((c) => (c === window.location.origin ? `${window.location.origin}/p/${r.data.restaurant_id}/menu` : c));
    }).catch(() => {});
  }, []);

  const generate = async () => {
    try {
      const r = await api.get("/tools/qr", { params: { content }, responseType: "blob" });
      setQrUrl(URL.createObjectURL(r.data));
    } catch (err) { toast.error(apiError(err)); }
  };

  const download = () => {
    const a = document.createElement("a");
    a.href = qrUrl;
    a.download = "qrcode.png";
    a.click();
  };

  const loadReservations = async () => {
    try {
      const r = await api.get("/reservations", { params: { date } });
      setReservations(r.data.filter((x) => ["da_confermare", "confermata", "in"].includes(x.status)));
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="space-y-5 max-w-3xl" data-testid="strumenti-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900">Strumenti</h1>
        <p className="text-xs text-zinc-500">Strumenti operativi per il lavoro quotidiano del ristorante.</p>
      </div>

      <section className="bg-white border border-zinc-200 rounded-lg p-5 space-y-4" data-testid="qr-tool">
        <div className="flex items-center gap-2">
          <QrCode size={18} weight="bold" className="text-zinc-700" />
          <h2 className="font-display font-semibold text-zinc-900">Generatore QR Code</h2>
        </div>
        <p className="text-xs text-zinc-500">Crea il QR di un link (landing evento, modulo prenotazioni, pagina recensioni…) da stampare o condividere.</p>
        <div className="flex gap-2 flex-wrap">
          <input value={content} onChange={(e) => setContent(e.target.value)}
            className="flex-1 min-w-60 h-11 px-3 rounded-md border border-zinc-300 text-sm" data-testid="qr-content" />
          <button onClick={generate} className="h-11 px-5 rounded-md bg-zinc-900 text-white text-sm font-semibold" data-testid="qr-generate">
            Genera QR
          </button>
        </div>
        {rid && (
          <div className="flex gap-2 flex-wrap">
            <span className="text-[11px] font-semibold text-zinc-500 self-center">Preset:</span>
            <button onClick={() => setContent(`${window.location.origin}/p/${rid}/menu`)} data-testid="qr-preset-menu"
              className="h-8 px-3 rounded-full bg-sky-50 border border-sky-300 text-[11px] font-bold text-sky-700">Menu digitale</button>
            <button onClick={() => setContent(`${window.location.origin}/p/${rid}`)} data-testid="qr-preset-prenotazioni"
              className="h-8 px-3 rounded-full bg-white border border-zinc-300 text-[11px] font-bold text-zinc-600">Modulo prenotazioni</button>
          </div>
        )}
        {qrUrl && (
          <div className="flex items-center gap-4">
            <img src={qrUrl} alt="QR Code" className="w-40 h-40 border border-zinc-200 rounded-lg" data-testid="qr-preview" />
            <button onClick={download} className="h-10 px-4 rounded-md border border-zinc-300 text-xs font-semibold flex items-center gap-2"
              data-testid="qr-download"><DownloadSimple size={15} /> Scarica PNG</button>
          </div>
        )}
      </section>

      <section className="bg-white border border-zinc-200 rounded-lg p-5 space-y-4 print:p-0 print:border-0" data-testid="segnaposto-tool">
        <div className="flex items-center gap-2 print:hidden">
          <Printer size={18} weight="bold" className="text-zinc-700" />
          <h2 className="font-display font-semibold text-zinc-900">Generatore segnaposto</h2>
        </div>
        <p className="text-xs text-zinc-500 print:hidden">Stampa i segnaposto per le prenotazioni di un giorno.</p>
        <div className="flex gap-2 flex-wrap print:hidden">
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
            className="h-11 px-3 rounded-md border border-zinc-300 text-sm" data-testid="segnaposto-date" />
          <button onClick={loadReservations} className="h-11 px-5 rounded-md bg-zinc-900 text-white text-sm font-semibold"
            data-testid="segnaposto-load">Carica prenotazioni</button>
          {reservations?.length > 0 && (
            <button onClick={() => window.print()} className="h-11 px-5 rounded-md border border-zinc-300 text-sm font-semibold"
              data-testid="segnaposto-print">Stampa</button>
          )}
        </div>
        {reservations && (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="segnaposto-list">
            {reservations.length === 0 && <p className="text-sm text-zinc-400 col-span-3">Nessuna prenotazione attiva in questa data.</p>}
            {reservations.map((r) => (
              <div key={r.id} className="border-2 border-dashed border-zinc-300 rounded-lg p-4 text-center print:break-inside-avoid">
                <div className="font-extrabold text-zinc-900">{r.customer_name}</div>
                <div className="text-xs text-zinc-500">{r.time} · {r.party_size} ospiti</div>
                {r.table_number && <div className="text-xs font-bold text-zinc-700 mt-1">Tavolo {r.table_number}</div>}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
